module.exports = __webpack_public_path__ + "img/2_2.97ba29c1.png";